import React, {Fragment} from 'react';
import {
  VideoOffIcon,
  VideoOnIcon,
  MicOffIcon,
  MicOnIcon,
} from '@100mslive/react-icons';
import {Tooltip, IconButton} from '@100mslive/roomkit-react';
import {
  useAVToggle,
  parsedUserAgent,
  useHMSActions,
  useHMSStore,
  selectIsLocalAudioEnabled,
  selectIsLocalVideoEnabled,
} from '@100mslive/react-sdk';
import './commonStyle.css'

const isMacOS = parsedUserAgent.getOS().name.toLowerCase() === 'mac os';

export const AudioVideoToggle = ({compact,showText}:any) => {
  const {isLocalVideoEnabled, isLocalAudioEnabled} = useAVToggle();
  const audioEnabled = useHMSStore(selectIsLocalAudioEnabled);
  const videoEnabled = useHMSStore(selectIsLocalVideoEnabled);
  const hmsActions = useHMSActions();
  async function toggleAudio() {
    await hmsActions.setLocalAudioEnabled(!audioEnabled);
  }

  async function toggleVideo() {
    await hmsActions.setLocalVideoEnabled(!videoEnabled);
  }
  return (
    <Fragment>
      {true ? (
        <Tooltip
          title={`Turn ${videoEnabled ? 'off' : 'on'} video (${
          isMacOS ? '⌘' : 'ctrl'
        } + e)`}>
          <div style={{marginRight:10}} className='videoAudioBtn' data-testid="video_btn" key="toggleVideo" onClick={toggleVideo}>
            {!videoEnabled ? (
              <div style={{backgroundColor:videoEnabled?'':'',padding:4,borderRadius:4}}>
                <VideoOffIcon color='white' data-testid="video_off_btn" />
                {showText && <div style={{fontSize:12,color:'white'}}>Video</div>}
              </div>
            ) : (
              <div style={{padding:4,borderRadius:4}}>
                <VideoOnIcon color='white' data-testid="video_on_btn" />
                {showText && <div style={{fontSize:12,color:'white'}}>Video</div>}
              </div>
            )}
          </div>
        </Tooltip>
      ) : null}
      {true ? (
         <Tooltip
         title={`Turn ${audioEnabled ? 'off' : 'on'} audio (${
           isMacOS ? '⌘' : 'ctrl'
         } + d)`}>
         <div style={{marginTop:1}} className='videoAudioBtn videoBtn' data-testid="audio_btn" key="toggleAudio" onClick={()=>toggleAudio()}>
           {!audioEnabled ? (
             <div style={{backgroundColor:audioEnabled?'':'',padding:4,borderRadius:4}}>
               <MicOffIcon color='white' data-testid="audio_off_btn" />
               {showText  && <div style={{fontSize:12,color:'white'}}>Audio</div>}
             </div>
           ) : (
             <div style={{padding:4,borderRadius:4}}>
               <MicOnIcon color='white' data-testid="audio_on_btn" />
              {showText && <div style={{fontSize:12,color:'white'}}>Audio</div>}
             </div>
           )}
         </div>
       </Tooltip>
      ) : null}
    </Fragment>
  );
};
